<template>
  <div>
    <div class="page-title">編輯訂單</div>
    <div class="page-box">
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row class="row-list" :gutter="20">
        <el-col :span="12"> 訂單編號 : {{ formLabelAlign.orderNo }}</el-col>
        <el-col :span="12"
          >用戶電郵 :<span v-if="formLabelAlign.parent">{{ formLabelAlign.parent.email  }}</span>
        </el-col>
      </el-row>
      <el-row class="row-list" :gutter="20">
        <el-col :span="12">
          訂單日期 : {{ formLabelAlign.createdAt | formatDate }}</el-col
        >
        <el-col :span="12">訂單金額 : {{ formLabelAlign.totalPrice }}</el-col>
      </el-row>
      <el-form label-position="top" label-width="80px" :model="formLabelAlign">
        <el-row class="row-list" :gutter="20">
          <el-col :span="12"
            ><el-form-item label="">
              <div slot="label">
                <div class="label-text">
                  付款類型
                  <span class="star-mark"> *</span>
                </div>
              </div>
              <el-select v-model="formLabelAlign.payType" disabled clearable placeholder="">
                <el-option
                  v-for="(item, index) in paymentType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select> 
             
            </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="">
              <div slot="label">
                <div class="label-text">
                  支付類型
                  <span class="star-mark"> *</span>
                </div>
              </div>
              <el-select v-model="formLabelAlign.status" disabled clearable placeholder="">
                <el-option
                  v-for="(item, index) in payStatus"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>
        <el-row class="row-list" :gutter="20">
          <el-col :span="12"
            ><el-form-item label="交易編號">
              <el-input v-model="formLabelAlign.payId" disabled></el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="推廣碼">
              <el-input v-model="formLabelAlign.promotionCode" disabled></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-form-item label="備註">
          <el-input v-model="formLabelAlign.remark"></el-input>
        </el-form-item>
      </el-form>

      <vue-dividing-line title="年級信息"></vue-dividing-line>
      <div>
     <el-table stripe :data="formLabelAlign.orderItems" style="width: 100%;">
          <el-table-column prop="grade" label="年級"> </el-table-column>
          <el-table-column prop="student" label="學生帳戶名稱">
          </el-table-column>
          <el-table-column prop="startDate" label="訂閱開始時間">
          </el-table-column>
          <el-table-column prop="endDate" label="訂閱結束時間">
          </el-table-column>
          <el-table-column prop="price" label="價格 ($)"> </el-table-column>
          <el-table-column prop="payPrice" label="實付價格($)"> </el-table-column>
      </el-table>
      </div>
      <div class="page-button">
        <el-button type="info" @click="onConfirm">確定</el-button>
        <el-button type="success" @click="onBack">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderDetail,putOrder } from "@/api/order";
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detail: {},
      formLabelAlign: {
        id: 0,
        number: "string",
        lang: 0,
        gradeId: 0,
        grade: {
          id: 1,
          name: "string",
          price: 0,
        },
        startDate: "string",
        endDate: "string",
        passScore: 0,
        homeworkScopes: [
          {
            id: 0,
            homeworkId: 0,
            topicId: 0,
            practiseId: 0,
            randomNumber: 0,
          },
        ],
        students: [
          {
            id: 1,
            userNo: "S001",
            name: "草莓",
            gender: 0,
            branchSchool: {
              id: 1,
              name: {
                en: "string",
                zhTc: "string",
              },
              abbreviation: "string",
            },
            password: "student1234",
            confirmPassword: "student1234",
            grade: {
              id: 1,
              name: "string",
              price: 0,
            },
            avatar: "https://image.baidu.com/search/detail?ct=503316480",
            birthday: "2020-11-11",
            studentCode: "string",
          },
        ],
      },
    };
  },
  created() {
    this.getOrderDetail();
  },
  methods: {
    onConfirm(){
      this.putOrder()
    },
    onProgramText(id) {
      let path = `/order/${id}`;
      // this.$router.push({ path: `/order/${id}` });
      this.resolveRouter(path)
    },
    putOrder(){
      putOrder(this.id,this.formLabelAlign).then(() => {
        this.$message({
          message: "修改成功",
          type: "success",
        });
      })
    },
    getOrderDetail() {
      getOrderDetail(this.id).then((v) => {
        this.formLabelAlign = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  margin: 20px 0;
  background-color: #fff;
  padding: 20px;
}
.row-list {
  margin-bottom: 10px;
}
.page-button {
  text-align: center;
}
::v-deep {
  .el-select {
    width: 100%;
  }
}
</style>